export const UPDATE_LOCALE = "UPDATE_LOCALE";


// WEBPACK FOOTER //
// ./modules/process-locale-post/actions/actionTypes.ts